let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ha2w7")).then(() => parcelRequire('jfOYz'));